import { NgModule } from "@angular/core";
import { IAccount } from "@comunicare/comunicare-interfaces";

@NgModule()
export class UserHelper {
  public static getOrganisation(account: IAccount): string {
    return account?.managingOrganizations[0]?.display;
  }

  public static getHealthcareService(account: IAccount): string {
    return account?.healthcareService[0]?.display;
  }
}
